import { render } from "./DataLaporan.vue?vue&type=template&id=3c64c576"
import script from "./DataLaporan.vue?vue&type=script&lang=js"
export * from "./DataLaporan.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__